import {POPUP, PopupNotif} from "back/commons/widgets/popups";
import {IInfoBrokerPointer} from "lib/commons/infos";
import {EHttpStatusCode, IBody, IEndPoint, IO, RespError, UrlQs} from "lib/commons/io/io";
import {IReg, IUiEnv, REG} from 'lib/commons/registry';
import {ESrcRights, ISecurityCtxPointer, SEC} from 'lib/commons/security';
import {CDM} from "lib/commons/utils/cdm";
import {DOM} from "lib/commons/xml/dom";
import {ChainUniverse, IChainEnv} from "lib/wsp/chain";
import {EItStatus, ITEM, srcRefSub} from "lib/wsp/item";
import {ESrcField, ESrcSt, JSrcFields, JSrcFieldsTree, JSrcHistNodes, JSrcIdent, SRC, srcId, srcRef, srcUri} from "lib/wsp/src";
import "lib/wsp/wsp_Perms";
import {WspMetaUi} from "lib/wsp/wspMetaUi";
import {EWspChangesEvts, EWspWorkingSt, IWspsLivePlacePointer, WspsLive, WspsLivePlace} from "lib/wsp/wspsLive";
import {JUserRolesMap, JUserSpecifiedRolesMap} from "lib/commons/roles";
import {ERROR} from "lib/core/errorReport";

/** Typage du code d'un atelier. */
export type wspCd = string;

/** Typage des uri incluant le code de l'atelier. */
export type wspUri = string; // {wspCd}/{srcUri}
export type wspId = string; // {wspCd}/{srcId}
export type wspRef = wspId | wspUri;

/**
 * Serveur d'accès aux ateliers.
 */
export class WspSrv {

	protected _wspsLive: WspsLive;

	get reg(): IReg<IChainEnv> {return this.chain.reg}

	constructor(public readonly chain: ChainUniverse, public readonly config: OWspSrvConfig) {}

	/** Gestionnaire des ateliers en communication instantannée avec le serveur (webSocket). */
	get wspsLive(): WspsLive {
		if (!this._wspsLive) this._wspsLive = new WspsLive(this);
		return this._wspsLive;
	}
}

/** deprecated : uniquement désactivable */
export interface OWspFeatures {
	publicWsp?: "alwaysTrue" | "alwaysFalse" | "trueByDefault" | "falseByDefault" | "deprecated" | undefined
	extIt?: "alwaysTrue" | "alwaysFalse" | "trueByDefault" | "falseByDefault" | "deprecated" | undefined
	airIt?: "alwaysTrue" | "alwaysFalse" | "trueByDefault" | "falseByDefault" | "deprecated" | undefined
	//mirror
}

export interface OWspSrvConfig {
	adminWspUrl?: IEndPoint
	wspMetaEditorUrl?: IEndPoint
	wspAgtUrl?: IEndPoint
	wspGenUrl?: IEndPoint
	pubUrl?: IEndPoint
	exportUrl?: IEndPoint
	importUrl?: IEndPoint
	wspDavUrl?: IEndPoint
	drfUrl?: IEndPoint
	drvUrl?: IEndPoint
	versionUrl?: IEndPoint
	wspSrcUrl?: IEndPoint
	historyUrl?: IEndPoint
	privateFolderUrl?: IEndPoint
	tasksUrl?: IEndPoint
	itemDynGenUrl?: IEndPoint
	searchUrl?: IEndPoint
	diffUrl?: IEndPoint
	/** spécifique FS */
	adminWspFsUrl?: IEndPoint
	/** Racine des Svc des ateliers. */
	wspSvcUrl?: IEndPoint
	wspSvcExistUrl?: IEndPoint
	/** Services de l'atelier */
	wspSvcSkinSet?: (wspCode: string) => IEndPoint
	remoteHouseOt?: boolean
}

export function configWspSrv(webFrameUrl: IEndPoint, config?: OWspSrvConfig): OWspSrvConfig {
	if (!config) config = {} as OWspSrvConfig;
	if (!config.adminWspUrl) config.adminWspUrl = webFrameUrl.resolve("u/adminWsp/");
	if (!config.wspMetaEditorUrl) config.wspMetaEditorUrl = webFrameUrl.resolve("u/wspMetaEditor");
	if (!config.wspAgtUrl) config.wspAgtUrl = webFrameUrl.resolve("u/wspAgt");
	if (!config.wspGenUrl) config.wspGenUrl = webFrameUrl.resolve("u/wspGen");
	if (!config.pubUrl) config.pubUrl = webFrameUrl.resolve("u/pub/");
	if (!config.exportUrl) config.exportUrl = webFrameUrl.resolve("u/export");
	if (!config.importUrl) config.importUrl = webFrameUrl.resolve("u/import");
	if (!config.wspDavUrl) config.wspDavUrl = webFrameUrl.resolve("u/wspDav/");
	if (!config.drfUrl) config.drfUrl = webFrameUrl.resolve("u/drf");
	if (!config.drvUrl) config.drvUrl = webFrameUrl.resolve("u/drv");
	if (!config.versionUrl) config.versionUrl = webFrameUrl.resolve("u/version");
	if (!config.historyUrl) config.historyUrl = webFrameUrl.resolve("u/history");
	if (!config.wspSrcUrl) config.wspSrcUrl = webFrameUrl.resolve("u/wspSrc");
	if (!config.privateFolderUrl) config.privateFolderUrl = webFrameUrl.resolve("u/privateFolder/");
	if (!config.tasksUrl) config.tasksUrl = webFrameUrl.resolve("u/tasks");
	if (!config.itemDynGenUrl) config.itemDynGenUrl = webFrameUrl.resolve("u/itemDynGen/");
	if (!config.searchUrl) config.searchUrl = webFrameUrl.resolve("u/search");
	if (!config.diffUrl) config.diffUrl = webFrameUrl.resolve("u/wspDiff");
	/** spécifique FS */
	if (!config.adminWspFsUrl) config.adminWspFsUrl = webFrameUrl.resolve("u/adminWspFs/");
	/** Services du wsp **/
	if (!config.wspSvcUrl) config.wspSvcUrl = webFrameUrl.resolve("repos/");
	if (!config.wspSvcExistUrl) config.wspSvcExistUrl = webFrameUrl.resolve("*repos/");
	if (!config.wspSvcSkinSet) config.wspSvcSkinSet = (wspCode: string) => config.wspSvcUrl.resolve(wspCode + "/skinSet")
	return config;
}


export interface JWspTypeInst {
	wspType: JWspType
	wspOptions?: JWspType[]
}

export interface JWspType {
	uri: string,
	key: string
	version: string
	lang?: string
	title?: string
	desc?: string
}

export interface JWspDefProps {
	desc?: string
	publicWsp?: 'true' | 'false'
	airIt?: 'true' | 'false'
	extIt?: 'true' | 'false'
	prxIt?: 'true' | 'false'
	mirror?: 'true' | 'false'
	drfRefWsp?: string
	draftTitle?: string
	drvAxis?: string
	drvDefaultSrcFindPath?: string;
	drvMasterWsp?: string
	/**
	 * wspPropsOpts 'drvWspUsedBy'
	 * Liste des codes de dérivation exploitant cette dérivation
	 * 	ATTENTION : propriété non liée au WSP dont l'évolution de la valeur ne donne pas lieu à un reload du wsp :
	 * 		la valeur est formellement juste au moment de l'interrogation uniquement
	 */
	drvWspUsedBy?: string
	/**
	 * wspPropsOpts 'listDrvs'
	 * Liste des ateliers DRV exploitant cet atelier
	 * ATTENTION : propriété non liée au WSP dont l'évolution de la valeur ne donne pas lieu à un reload du wsp :
	 * 		la valeur est formellement juste au moment de l'interrogation uniquement
	 */
	listDrvs?: string
	/**
	 * wspPropsOpts 'listDrfs'
	 * Liste des ateliers DRF exploitant *directement* cet atelier (ie : pas de parcours de la descendance)
	 * 	ATTENTION : propriété non liée au WSP dont l'évolution de la valeur ne donne pas lieu à un reload du wsp :
	 * 		la valeur est formellement juste au moment de l'interrogation uniquement
	 */
	listDrfs?: string
}

export interface JWspProviderProps {
	backEnd: 'fs' | 'odb'
	defaultContentPath?: string
	defaultGenPath?: string
}

export interface JInfoWsp {
	wspCd: string
	status: EWspLoadingStatus
	title: string
	alias: string
	skins?: string[]
	props: JWspDefProps
	wspProvider: JWspProviderProps
	srcFields?: JSrcFields //fields sur le noeud racine de l'atelier (roles, rights...)
	wspMeta?: JWspTypeInst
	//Props suivant dispo uniquement si status='ok'|'failed'
	isMigrationNeeded?: boolean
	allItemsLoaded?: "no" | "working" | "ok"
	wspTypeWarn?: 'unknown'
	wspType: JWspType
	wspOptions: JWspType[]
	//Props uniquement présent dans les WSP FS local
	content?: string
	//Props uniquement présent dans les WSP local
	gen?: string
}

/** Roles  */
export interface JWspProviderRolesSet {
	roles?: Dict<JNodeRole>
	wsps: Dict<JWspRolesSet>
}

export interface JWspRolesSet {
	title: string
	nodes: JNodeRolesSet
	infoWsp: JWspInfoInList
}

export interface JNodeRolesSet {
	name: string
	roles?: Dict<JNodeRole>
	ch?: JNodeRolesSet[]
}

export interface JNodeRole {
	allowed?: string[]
	denied?: string[]
	userUnknown?: true | undefined
}


export interface JWspInfoInList {
	wspCd: wspCd
	status: EWspLoadingStatus
	title: string
	alias: string
	props: JWspDefProps
	srcFields?: {
		/** Liste de roles du user pour l'objet métier de ce contexte. */
		srcRoles: string[]
		/** Droits systèmes de l'objet métier (ex: un item de l'historique est toujours read-only). voir Api Src. */
		srcRi?: ESrcRights
	} //fields sur le noeud racine de l'atelier (roles, rights...)
	// Roles spécifiés sur le noeud racine de l'atelier
	srcSpecifiedRoles?: JUserRolesMap
	//Dispo uniquement si status='ok'|'failed'
	isMigrationNeeded?: boolean
	wspTypeWarn?: 'unknown'
	wspType: JWspType
	wspOptions: JWspType[]
}

/** Statut de chargement d'un wsp */
export const enum EWspLoadingStatus {
	notLoaded = 'notLoaded',
	ok = 'ok',
	failed = 'failed',
	loading = 'loading',
	noWsp = 'noWsp'
}

export interface JWspCreateParamsFS {
	title?: string;
	desc?: string;
	code: string;
	folderContent?: string;
	folderGen?: string;
}

export interface JWspCreateParamsDB {
	title: string;
	alias?: string;
	desc?: string;
	skins?: string[];
	publicWsp?: boolean;
	airIt?: boolean;
	extIt?: boolean;
	mirror?: boolean;
}

export interface JWspCreateParamsDB_DRF extends JWspCreateParamsDB {
	wspRef?: string;
	draftTitle?: string;
}

export interface JWspCreateParamsDB_DRV extends JWspCreateParamsDB {
	wspMaster?: string;
	drvAxis?: string;
	drvDefaultSrcFindPath?: string[];
}

interface JWspUpdateParamsFS {
	title?: string;
	desc?: string;
}

interface JWspUpdateParamsDB {
	title?: string;
	alias?: string;
	desc?: string;
	skins?: string[];
	publicWsp?: boolean;
	airIt?: boolean;
	extIt?: boolean;
	mirror?: boolean;
}

interface JWspUpdateParamsDB_DRF extends JWspUpdateParamsDB {
	wspRef?: string;
	draftTitle?: string;
}

interface JWspUpdateParamsDB_DRV extends JWspUpdateParamsDB {
	wspMaster?: string;
	drvAxis?: string;
	drvDefaultSrcFindPath?: string[];
}


interface JWspDeleteParamsFS {
	deleteGen: 'true' | 'false';
	deleteContent?: 'true' | 'false';
}

interface JWspDeleteParamsDB {
	deleteGen: 'true' | 'false';
}

/**
 *
 */
export class Wsp {

	/**
	 * Le registre du Wsp sera enrichi au chargement de son wspMetaUi.
	 */
	reg: IReg<IWspEnv>;

	/**
	 * InfoWsp si status === "ok".
	 * Si undefined : pas encore chargé.
	 * Si null : réponse du serveur en echec.
	 */
	infoWsp: JInfoWsp | undefined | null;

	/** InfoWsp si status !== "ok". */
	infoWspError: JInfoWsp;

	/**
	 * Si non null, atelier actuellement en cours de migration.
	 * Utiliser waitForLoading()
	 */
	migrating?: Promise<this>;

	/**
	 * Si non null, atelier actuellement en cours de chargement intégral (mode allItemsLoaded).
	 */
	fullLoading?: Promise<this>;

	/**
	 * Modèle documentaire de cet atelier.
	 * Si undefined : pas encore chargé.
	 * Si null : réponse du serveur en echec.
	 */
	wspMetaUi: WspMetaUi | undefined | null;

	lastNetError: RespError;

	protected _shortDescFields: ESrcField[];
	protected _longDescFields: ESrcField[];
	protected _shortDescDef: string;
	protected _longDescDef: string;

	protected countUsed = 0;

	constructor(public readonly wspServer: WspSrv, public code: wspCd, infoWsp?: JInfoWsp, wspMetaUi?: WspMetaUi) {
		this.reg = REG.createSubReg<IWspEnv>(wspServer.reg); //Note SubReg obligatoire car reg.resetExtPoints() au rechargement du wspMeta.
		this.reg.env.wsp = this;
		if (infoWsp) {
			if (infoWsp.status === "loading") this.waitForLoad();
			else this.setInfoWsp(infoWsp);
			if (wspMetaUi) {
				this.wspMetaUi = wspMetaUi;
				this.reg.copyFrom(wspMetaUi.reg);
			}
		}
	}

	/** Field srcUri ou srcId à privilégier en fonction de l'implémentation du WspProvider. */
	get srcRefField(): 'srcUri' | 'srcId' {return this.backEnd === 'odb' ? 'srcId' : 'srcUri'}

	/** Les infos de l'atelier sont-elles chargées, que l'atelier soit en erreur ou non. */
	get isLoaded(): boolean {return this.infoWsp != null || (this.infoWspError != null && this.infoWspError.status != EWspLoadingStatus.notLoaded)}

	/** L'atelier est-il disponible, statut ok et modèle documentaire disponible. */
	get isAvailable(): boolean {return this.infoWsp != null && !this.infoWsp.wspTypeWarn && this.wspMetaUi != null && !this.migrating && !this.fullLoading}

	/** L'atelier est-il en cours de chargement complet de son contenu. */
	get isFullLoading(): boolean {return this.fullLoading != null}

	/** L'atelier est-il intégralement chargé. */
	get isFullLoaded(): boolean {return this.infoWsp?.allItemsLoaded === "ok" || false}

	get isInError(): boolean {return this.infoWspError != null || this.wspMetaUi === /* === pour != undefined */ null}

	get isDeleted(): boolean | undefined {return this.infoWsp && this.infoWsp.srcFields ? this.infoWsp.srcFields.srcSt === -1 : undefined}

	get isAccessDenied(): boolean {return this.lastNetError && this.lastNetError.response.status === EHttpStatusCode.forbidden}

	get isPublic(): boolean | undefined {return this.infoWsp ? this.infoWsp.props.publicWsp === 'true' : undefined}

	get isAirItem(): boolean | undefined {return this.infoWsp ? this.infoWsp.props.airIt === 'true' : undefined}

	get isExtItem(): boolean | undefined {return this.infoWsp ? this.infoWsp.props.extIt === 'true' : undefined}

	get isPrxItem(): boolean | undefined {return this.backEnd === "odb" /*todo this.infoWsp ? this.infoWsp.props.prxIt === 'true' : undefined*/}

	get backEnd(): 'fs' | 'odb' {return this.reg.env.universe.config.backEnd}

	get wspTitle(): string | undefined {
		if (this.infoWsp && this.infoWsp.title) return this.infoWsp.title;
		if (this.infoWspError && this.infoWspError.title) return this.infoWspError.title;
		return this.code;
	}

	get wspAlias(): string | undefined {return this.infoWsp ? this.infoWsp.alias : undefined}

	get wspType(): JWspTypeInst | undefined {return this.infoWsp && this.infoWsp.wspType ? this.infoWsp : undefined}

	get wspDefProps(): JWspDefProps | undefined {return this.infoWsp ? this.infoWsp.props : undefined}

	/** Evalue si le backend de ce wsp implémente une fonction (indépendamment des caractéristqiues du wspMeta en cours). */
	hasFeature(feat: 'revealFs' | 'trash' | 'history' | 'version' | 'tasks' | 'liveCycle' | 'resp' | 'drv' | 'drf' | 'git'): boolean | undefined {
		const backEnd = this.backEnd;
		if (backEnd === undefined) return undefined;
		if (backEnd === 'fs') {
			if (feat === 'revealFs') return true;
			if (feat === 'git') return true;
		} else {
			if (feat === 'trash') return true;
			if (feat === 'history') return true;
			if (feat === 'version') return true;
			if (feat === 'tasks') return true;
			if (feat === 'liveCycle') return true;
			if (feat === 'resp') return true;
			if (feat === 'drv') return this.reg.env.universe.wspServer.chain.config.drv;
			if (feat === 'drf') return this.reg.env.universe.wspServer.chain.config.drf;
		}
		return false;
	}

	/**
	 * Attend que les informations sur l'atelier soient chargés
	 * (que l'atelier soit en erreur ou non coté serveur).
	 * Promesse rejetée si accès au serveur impossible.
	 *
	 * Le modèle documentaire n'est pas chargé ici, voir waitForAvailable().
	 */
	async waitForLoad(): Promise<this> {
		if (this.isLoaded) return this;
		if (this.infoWsp === null) throw Error("Fetch infoWsp previously failed: " + this.lastNetError);
		if (this._wspInfoLoading == null) {
			const fields = this.backEnd === "odb" ? "srcRoles*srcRi*srcDt*srcSt" : "srcRoles*srcRi*srcDt*srcSt*gitSt";
			this._wspInfoLoading = this.wspServer.config.adminWspUrl.fetchJson<JInfoWsp>(IO.qs("cdaction", "InfoWsp", "param", this.code, "fields", fields)).then((infoWsp) => {
				if (infoWsp && infoWsp.status === "loading") return new Promise<this>((resolve) => {
					this._wspInfoLoading = null;
					setTimeout(() => resolve(this.waitForLoad()), 500);
				});
				this.setInfoWsp(infoWsp);
				return this;
			}, (e) => {
				if (e instanceof RespError) this.lastNetError = e;
				this.setInfoWsp(null); //Marque le fetch en erreur.
				throw e;
			});
		}
		return this._wspInfoLoading;
	}

	/**
	 * Attend que l'atelier et le modèle documentaire soient chargés.
	 * Le statut de l'atelier n'est pas évalué ici, voir waitForAvailable().
	 */
	async waitForWspMetaUiAvailable(): Promise<this> {
		if (this.wspMetaUi !== null) {
			if (this._wspMetaUiLoading != null) {
				await this._wspMetaUiLoading;
			} else {
				await this.waitForLoad();
				if (this.shouldLoadWspMetaUi()) {
					if (this._wspMetaUiLoading != null) await this._wspMetaUiLoading;
					else await this.fetchWspMetaUi();
				}
			}
		}
		return this;
	}

	/**
	 * Attend que l'atelier et le modèle documentaire soient chargés et disponibles, pas en erreur.
	 * Promesse rejetée dans les autres cas.
	 */
	async waitForAvailable(notifFrom?: HTMLElement): Promise<this> {
		try {
			if (!this.wspMetaUi) {
				if (!this.isLoaded) {
					this.notifWaiting(notifFrom, "Chargement de l'atelier...");
					await this.waitForLoad();
				}
				if (this.infoWspError != null) {
					if (this.infoWspError.status === EWspLoadingStatus.noWsp) {
						this.notifWaiting(notifFrom, "Atelier non trouvé");
					} else {
						this.notifWaiting(notifFrom, "Atelier en erreur");
					}
					throw Error("WspInfo in error");
				}
				if (this.infoWsp === null) {
					this.notifWaiting(notifFrom, "Accès impossible à l'atelier");
					throw Error("Fetch infoWsp previously failed");
				}
				if (this.wspMetaUi === null) {
					this.notifWaiting(notifFrom, "Accès impossible aux propriétés de l'atelier");
					throw Error("Fetch wspMeta previously failed");
				}
				if (this._wspMetaUiLoading != null) {
					await this._wspMetaUiLoading;
				} else {
					if (this.shouldLoadWspMetaUi()) {
						this.notifWaiting(notifFrom, "Chargement de l'atelier...");
						if (this._wspMetaUiLoading != null) await this._wspMetaUiLoading;
						else await this.fetchWspMetaUi();
					}
				}
			}
			if (this.migrating) {
				this.notifWaiting(notifFrom, "Migration de l'atelier en cours...");
				await this.migrating;
				await this.waitForAvailable(notifFrom); //réévaluation des cas d'erreur
			}
			if (this.fullLoading) {
				this.notifWaiting(notifFrom, "Chargement de l'atelier complet en cours...");
				await this.fullLoading;
				await this.waitForAvailable(notifFrom); //réévaluation des cas d'erreur
			}
		} finally {
			this.clearAllNotifWaiting();
		}
		return this;
	}

	protected shouldLoadWspMetaUi(): boolean {
		if (this.wspMetaUi != null) return false;//non, déjà chargé
		if (this.infoWsp != null) return true;//oui, infoWsp dispo
		if (this.infoWspError != null) console.log("this.infoWspError.status:::", this.infoWspError.status);
		if (this.infoWspError != null && this.infoWspError.status !== EWspLoadingStatus.notLoaded && this.infoWspError.status !== EWspLoadingStatus.noWsp) return true; //oui, wsp en erreur mais chargeable
		return false; //oui, wsp pas utilisable
	}

	protected notifWaiting(notifFrom: HTMLElement, msg: string) {
		if (!notifFrom || notifFrom.offsetHeight == 0) return; //pas de contexte ou contexte graphique masqué.
		if (!this._lastWaitNotif) this._lastWaitNotif = new Map();
		let lastNotif = this._lastWaitNotif.get(notifFrom);
		if (lastNotif) {
			//précédente notif encore ouverte.
			lastNotif.setContent(msg);
		} else {
			//nouvelle motif
			lastNotif = POPUP.showNotif(msg, notifFrom, {autoHide: 0});
			this._lastWaitNotif.set(notifFrom, lastNotif);
			lastNotif.onNextClose().then(() => {this._lastWaitNotif.delete(notifFrom)});
		}
	}

	protected clearAllNotifWaiting() {
		if (this._lastWaitNotif) {
			for (const notif of this._lastWaitNotif.values()) {
				notif.close();
			}
			this._lastWaitNotif.clear();
		}
	}

	protected updateAllNotifWaiting(msg: string) {
		if (this._lastWaitNotif) {
			for (const notif of this._lastWaitNotif.values()) {
				notif.setContent(msg);
			}
		}
	}

	protected _lastWaitNotif: Map<HTMLElement, PopupNotif>;

	/**
	 * Ecoute les changements issus du server sur les propriétés de l'atelier.
	 * stopListenChanges() doit être en fin d'utilisation.
	 */
	listenChanges(): this {
		if (this.countUsed++ === 0) {
			const wspsLive = this.wspServer.wspsLive;
			if (wspsLive.isAvailable && !wspsLive.findWsp(this.code)) wspsLive.sendMsg({svc: 'wspChanges', type: 'listen', addWsp: this.code});
			wspsLive._wsps.add(this);
		}
		return this;
	}

	stopListenChanges(): this {
		if (--this.countUsed === 0) {
			const wspsLive = this.wspServer.wspsLive;
			wspsLive._wsps.delete(this);
			//Reset des états graphiques en cours : ce wsp étant éléminé de wspsLive._wsps
			// les events WebSockets 'fullLoaded' ou 'migratingDone'/'migratingFailed' ne seront jamais reçus,
			// les promesses associées ne sont donc jamais résolues.
			this.resetFullLoading();
			this.resetMigrating();
			if (wspsLive.isAvailable && !wspsLive.findWsp(this.code)) wspsLive.sendMsg({svc: 'wspChanges', type: 'listen', remWsp: this.code});
		}
		return this;
	}

	/** Créée une place avec ce wsp pré-enregistré pour écouter les events. */
	newPlaceWsp(): WspsLivePlace {
		const pl = this.wspServer.wspsLive.newPlace();
		pl.registerWsp(this); //préenregistrement.
		return pl;
	}

	/** Construit un objet fournissant les propriétés de l'atelier en respectant le le formalisme JSON d'update requis */
	makeParamsForUpdate(): JWspUpdateParamsFS | JWspUpdateParamsDB | JWspUpdateParamsDB_DRF | JWspUpdateParamsDB_DRV {
		let result = {};
		const infoWsp = this.infoWsp || this.infoWspError;
		if (this.backEnd == "fs") {
			if (infoWsp.props.desc) (result as JWspUpdateParamsFS).desc = infoWsp.props.desc;
			if (infoWsp.title) (result as JWspUpdateParamsFS).title = infoWsp.title;
		} else if (this.backEnd == "odb") {
			if (infoWsp.props.desc) (result as JWspUpdateParamsDB).desc = infoWsp.props.desc;
			if (infoWsp.title) (result as JWspUpdateParamsDB).title = infoWsp.title;
			if (infoWsp.alias) (result as JWspUpdateParamsDB).alias = infoWsp.alias;
			if (infoWsp.skins) (result as JWspUpdateParamsDB).skins = infoWsp.skins;
			if (infoWsp.props?.airIt) (result as JWspUpdateParamsDB).airIt = infoWsp.props.airIt === 'true';
			if (infoWsp.props?.extIt) (result as JWspUpdateParamsDB).extIt = infoWsp.props.extIt === 'true';
			if (infoWsp.props?.mirror) (result as JWspUpdateParamsDB).mirror = infoWsp.props.mirror === 'true';
			if (infoWsp.props?.publicWsp) (result as JWspUpdateParamsDB).publicWsp = infoWsp.props.publicWsp === 'true';
		}
		if (this.wspDefProps && this.wspDefProps.drfRefWsp) {
			if (infoWsp.props.draftTitle) (result as JWspUpdateParamsDB_DRF).draftTitle = infoWsp.props.draftTitle;
			if (infoWsp.props.drfRefWsp) (result as JWspUpdateParamsDB_DRF).wspRef = infoWsp.props.drfRefWsp;
		}
		if (this.wspDefProps && this.wspDefProps.drvAxis) {
			if (infoWsp.props.drvMasterWsp) (result as JWspUpdateParamsDB_DRV).wspMaster = infoWsp.props.drvMasterWsp;
			if (infoWsp.props.drvAxis) (result as JWspUpdateParamsDB_DRV).drvAxis = infoWsp.props.drvAxis;
			if (infoWsp.props.drvDefaultSrcFindPath) (result as JWspUpdateParamsDB_DRV).drvDefaultSrcFindPath = infoWsp.props.drvDefaultSrcFindPath.split(" ");
		}
		return result;
	}

	/**
	 * Le shortDesc retourné est potentiellement issu d'un cache.
	 * L'appelant DOIT donc le cloner s'il veut modifier l'objet (refs internes dans un tree...).
	 */
	async fetchShortDesc(srcRefSub: srcRefSub, uiContext?: HTMLElement): Promise<JSrcFields> {
		if (!this._pendingShortDescs) this._pendingShortDescs = new FetchSrcDescBulk(this, uiContext);
		let pending = this._pendingShortDescs.get(srcRefSub);
		if (!pending) pending = new FetchSrcDescPending(this._pendingShortDescs, srcRefSub, false);
		return pending.promise;
	}

	_pendingShortDescs?: FetchSrcDescBulk;

	/**
	 * Le shortDesc retourné est potentiellement issu d'un cache.
	 * L'appelant DOIT donc le cloner s'il veut modifier l'objet (refs internes dans un tree...).
	 */
	async fetchShortDescSubItems(srcRefSub: srcRefSub, uiContext?: HTMLElement): Promise<JSrcFields> {
		if (!this._pendingShortDescs) this._pendingShortDescs = new FetchSrcDescBulk(this, uiContext);
		let pending = this._pendingShortDescs.get(srcRefSub);
		if (!pending) pending = new FetchSrcDescPending(this._pendingShortDescs, srcRefSub, true);
		else pending.withSubItem = true;
		return pending.promise;
	}

	/**
	 * Le longDesc retourné est potentiellement issu d'un cache.
	 * L'appelant DOIT donc le cloner s'il veut modifier l'objet (refs internes dans un tree...).
	 */
	async fetchLongDesc(srcRef: srcRef, uiContext?: HTMLElement): Promise<JSrcFields> {
		let p = this._pendingLongDescFetch.get(srcRef);
		if (p) return p;
		p = WSP.fetchLongDesc(this, uiContext, srcRef);
		this._pendingLongDescFetch.set(srcRef, p);
		try {
			return await p;
		} finally {
			this._pendingLongDescFetch.delete(srcRef);
		}
	}

	protected _pendingLongDescFetch = new Map<srcRef, Promise<JSrcFields>>();

	/** Liste des srcFields du shortDesc, une fois intégré les particularités du desk, du wspProvider et du modèle documentaire. */
	getShortDescFields(): ESrcField[] {
		if (!this._shortDescFields) {
			this._shortDescFields = [...SRC.resolveAliasSrcFields(this.reg.mergeLists(this.backEnd === 'odb' ? 'srcFields:shortDesc:odb' : 'srcFields:shortDesc:fs', 'srcFields:shortDesc'))];
		}
		return this._shortDescFields;
	}

	/** Définition du shortDesc avec alias, une fois intégré les particularités du desk, du wspProvider et du modèle documentaire. */
	getShortDescDef(): string {
		if (!this._shortDescDef) {
			this._shortDescDef = this.reg.mergeLists(this.backEnd === 'odb' ? 'srcFields:shortDesc:odb' : 'srcFields:shortDesc:fs', 'srcFields:shortDesc').join('*');
		}
		return this._shortDescDef;
	}

	/** Liste des srcFields du longDesc, une fois intégré les particularités du desk, du wspProvider et du modèle documentaire. */
	getLongDescFields(): ESrcField[] {
		if (!this._longDescFields) {
			const set = SRC.resolveAliasSrcFields(this.reg.mergeLists(this.backEnd === 'odb' ? 'srcFields:longDesc:odb' : 'srcFields:longDesc:fs', 'srcFields:longDesc', this.backEnd === 'odb' ? 'srcFields:shortDesc:odb' : 'srcFields:shortDesc:fs', 'srcFields:shortDesc'));
			if (this.isExtItem) set.add("itFullUriInOwnerWsp");
			this._longDescFields = [...set];
		}
		return this._longDescFields;
	}

	/** Définition du longDesc avec alias, une fois intégré les particularités du desk, du wspProvider et du modèle documentaire. */
	getLongDescDef(): string {
		if (!this._longDescDef) {
			const list = this.reg.mergeLists<ESrcField | string/*alias*/>(this.backEnd === 'odb' ? 'srcFields:longDesc:odb' : 'srcFields:longDesc:fs', 'srcFields:longDesc', this.backEnd === 'odb' ? 'srcFields:shortDesc:odb' : 'srcFields:shortDesc:fs', 'srcFields:shortDesc');
			if (this.isExtItem) list.push("itFullUriInOwnerWsp");
			this._longDescDef = list.join('*');
		}
		return this._longDescDef;
	}

	/**
	 * Fonction de tri des contenus des espaces (et des dosssiers des items de ressources).
	 * Doit être identique à celui du moteur de recherche de l'atelier selon l'expression "Items".
	 *
	 * Projet de le rendre configurable (prop serveur du wsp) : espaces en 1er...
	 */
	get srcUriItemsSortFn(): (a: srcUri, b: srcUri) => number {
		return SRC.sortSrcUriTree;
	}

	async delete(deleteParams: JWspDeleteParamsFS | JWspDeleteParamsDB): Promise<void> {
		return this.wspServer.config.adminWspUrl.fetchVoid(IO.qs("cdaction", "DeleteWsp", "param", this.code, "deleteParams", CDM.stringify(deleteParams)), {method: "POST"});
	}

	async deletePermanently(deleteParams?: Jsonisable): Promise<void> {
		const qs = new UrlQs();
		qs.append("cdaction", "DeletePermanentlyWsp");
		qs.append("param", this.code);
		if (deleteParams) qs.append("deleteParams", CDM.stringify(deleteParams));
		return this.wspServer.config.adminWspUrl.fetchVoid("?" + qs.toString(), {method: "POST"});
	}

	async restore(): Promise<void> {
		return this.wspServer.config.adminWspUrl.fetchVoid(IO.qs("cdaction", "RestoreWsp", "param", this.code), {method: "POST"});
	}

	updateWspProps(updateParams: JWspUpdateParamsFS | JWspUpdateParamsDB | JWspUpdateParamsDB_DRF | JWspUpdateParamsDB_DRV): Promise<void> {
		return this.wspServer.config.adminWspUrl.fetchVoid(IO.qs("cdaction", "UpdateWspProps", "param", this.code, "updateParams", CDM.stringify(updateParams)), {method: "POST"});
	}

	/**
	 * Maj du wspType d'un atelier
	 * @param withMigration : si true, affecte le nouveau wspType en déclenchant la migration si nécessaire
	 * @param normalizeWspType : si true, demande la normalisation du wspType partiel passé en argument (langue inconnue, version inconnue, ...) par rapport aux packs installés
	 *		ATTENTION : l'objet wsp ne sera rafraîchi QUE suite aux remontées d'event WS, si (wsp.listenChanges())
	 */
	async updateWspType(wspType: JWspTypeInst, withMigration: boolean = false, normalizeWspType: boolean = false): Promise<this> {
		const initReq: RequestInit = {method: 'PUT', body: DOM.ser(WSPMETA.toWspTypeDom(wspType))};
		await this.wspServer.config.adminWspUrl.fetchJson<JInfoWsp>(IO.qs("cdaction", withMigration ? "MigrateUpdateWspType" : "UpdateWspType", "normaliseWspType", normalizeWspType, "param", this.code), initReq);
		// this.resetRemoteDatas();
		// if (infoWsp && infoWsp.status === "loading") {
		// 	this.setInfoWsp(undefined);
		// 	return this.waitForLoad();
		// }
		// this.setInfoWsp(infoWsp);
		return this;
	}

	/**
	 * Evalue si une migration est nécessaire pour affecter le wspMeta à l'atelier
	 * @return false : pas de migration nécessaire
	 * @return true : migration nécessaire
	 * @return Node : migration nécessaire mais necessite des prérequis décris par ce message
	 * @see  eu.scenari.commons.log.LogMsg.writeAsXmlFormat
	 */
	async isMigrationNeeded(wspType: JWspTypeInst): Promise<boolean | Element> {
		const initReq: RequestInit = {method: 'PUT', body: DOM.ser(WSPMETA.toWspTypeDom(wspType))};
		const vRespDom: Document = await this.wspServer.config.adminWspUrl.fetchDom(IO.qs("cdaction", "IsMigrationNeeded", "param", this.code), initReq);
		if (vRespDom.documentElement.nodeName === "noMigrationNeeded")
			return Promise.resolve(false);
		else if (vRespDom.documentElement.hasChildNodes())
			return Promise.resolve(vRespDom.documentElement.firstElementChild);
		else
			return Promise.resolve(true);
	}

	/** Appelé par ex. en cas de chgt de user. */
	forceReload(notifFrom?: HTMLElement): Promise<this> {
		if (this.isAvailable) {
			this.resetRemoteDatas();
			return this.waitForAvailable(notifFrom);
		}
		if (this.isLoaded) {
			this.resetRemoteDatas();
			return this.waitForLoad();
		}
		return Promise.resolve(this);
	}

	async forceAllItemsLoaded(notifFrom: HTMLElement): Promise<this> {
		if (this.infoWsp.allItemsLoaded === "ok") return this;
		if (!this.isAvailable) {
			await this.waitForAvailable(notifFrom);
			// @ts-ignore
			if (this.infoWsp.allItemsLoaded === "ok") return this;
		}
		this.notifWaiting(notifFrom, "Chargement de l'atelier complet en cours...");
		try {
			if (this.isFullLoading) {
				await this.fullLoading;
			} else {
				await this.wspServer.config.adminWspUrl.fetchVoid(IO.qs("cdaction", "ActivateModeLoadAllItems", "param", this.code), {method: "POST"});
			}
		} finally {
			this.clearAllNotifWaiting();
		}
		return this;
	}

	/** L'état de l'atelier coté serveur a été modifié. */
	_onWspChange(m: JWspStChangeMsg) {
		this.resetMigrating();
		this.resetFullLoading();
		if (m.wspSt === 'loaded' || m.wspSt === 'closed') {
			if (this.isLoaded) this.resetRemoteDatas();
			this.waitForAvailable();
		} else if (m.wspSt === 'migrating') {
			this.migrating = new Promise<this>((resolve: (r: this) => void): void => {this._migrResolver = resolve});
			this._dispatchWspLiveChange();
			this.updateAllNotifWaiting("Migration de l'atelier en cours...");
		} else if (m.wspSt === 'migratingDone' || m.wspSt === 'migratingFailed') {
			this.clearAllNotifWaiting();
			this._dispatchWspLiveChange();
		} else if (m.wspSt === 'fullLoading') {
			this.fullLoading = new Promise<this>((resolve): void => {this._fullLoadingResolver = resolve});
			this._dispatchWspFullLoadStateChange();
			this.updateAllNotifWaiting("Chargement complet de l'atelier en cours...");
		} else if (m.wspSt === 'fullLoaded') {
			if (this.infoWsp) this.infoWsp.allItemsLoaded = "ok";
			this._dispatchWspFullLoadStateChange();
			this.clearAllNotifWaiting();
		}
	}

	protected resetFullLoading() {
		if (this._fullLoadingResolver) {
			this._fullLoadingResolver(this);
			this._fullLoadingResolver = null;
		}
		this.fullLoading = null;
	}

	protected resetMigrating() {
		if (this._migrResolver) {
			this._migrResolver(this);
			this._migrResolver = null;
		}
		this.migrating = null;
	}

	/** Changement de perm sur l'atelier. */
	_onWspPermChange(m: JWspUriChangeMsg): Promise<this> {
		this.resetRemoteDatas();
		return this.waitForAvailable();
	}

	protected _dispatchWspLiveChange() {
		if (WspDEBUG) console.log("WspLiveChange:::", this.code, this);
		for (const place of this.wspServer.wspsLive._places) {
			if (place.isWspUsed(this)) place.eventsMgr.emitCatched("wspLiveStateChange", this);
		}
	}

	protected _dispatchWspFullLoadStateChange() {
		for (const place of this.wspServer.wspsLive._places) {
			if (place.isWspUsed(this)) place.eventsMgr.emitCatched("wspLiveFullLoadStateChange", this);
		}
	}

	protected _migrResolver: (r: this) => void;
	protected _fullLoadingResolver: (r: this) => void;

	/** Controle de fraicheur de l'atelier après une reconnexion webSocket. */
	async onWsConnectionRenewed(uriStates: JWspWorkingInitStates) {
		const wspState = uriStates[this.code];
		//si !wspState, cet atelier a été déclaré après la requete websocket d'init et avant la réponse du serveur
		//=>pas de reload
		if (!wspState) return;
		if (this.migrating) {
			if (WspDEBUG) console.log("Wsp.onWsConnectionRenewed::reload due to migrating::", wspState);
			this.resetRemoteDatas(); //Besoin de recharger le wspInfo pour isMigrationNeeded.
		} else {
			const infoWsp = this.infoWsp || this.infoWspError;
			if (infoWsp === null || this.wspMetaUi === null) {
				//infoWsp === null : accès impossible (ex: 403) on reset et retente
				//wspMetaUi === null : échec précédent, peut-être à présent résolu (relancement serveur)
				if (WspDEBUG) console.log("Wsp.onWsConnectionRenewed::tryLoad::", wspState);
				this.resetRemoteDatas();
			} else if (infoWsp && infoWsp.srcFields && wspState && infoWsp.srcFields.srcDt !== wspState.srcDt) {
				//infoWsp déjà chargé, mais Dt différent
				if (WspDEBUG) console.log("Wsp.onWsConnectionRenewed::reload::", wspState, infoWsp.srcFields);
				this.resetRemoteDatas();
			} else {
				this.resetFullLoading(); //srcDt n'est pas impacté par le statut fullLoading
			}
		}
		return this.waitForAvailable();
	}


	protected _wspInfoLoading: Promise<this>;
	protected _wspMetaUiLoading: Promise<WspMetaUi>;

	protected setInfoWsp(infoWsp: JInfoWsp) {
		this._wspInfoLoading = null;
		this.resetWspMetaUi();
		//console.log("infoWsp:::::::::::", infoWsp);
		if (infoWsp) {
			if (infoWsp.srcFields) {
				this.reg.env.securityCtx = SEC.createSub(this.wspServer.reg.env.securityCtx, infoWsp.srcFields.srcRoles, infoWsp.srcFields.srcRi, this);
			} else {
				this.reg.env.securityCtx = null;
			}
			switch (infoWsp.status) {
			case EWspLoadingStatus.ok :
				this.code = infoWsp.wspCd; //en cas d'accès par alias.
				this.infoWsp = infoWsp;
				this.infoWspError = null;
				break;
			case EWspLoadingStatus.failed :
			case EWspLoadingStatus.loading : //ne devrait jamais arriver.
				this.code = infoWsp.wspCd; //en cas d'accès par alias.
				this.infoWsp = null;
				this.infoWspError = infoWsp;
				if (WspDEBUG) console.log("WspInfo fetched with failed status:", infoWsp);
				break;
			case EWspLoadingStatus.notLoaded :
				this.code = infoWsp.wspCd; //en cas d'accès par alias.
				this.infoWsp = undefined;
				this.infoWspError = infoWsp;
				break;
			case EWspLoadingStatus.noWsp :
				this.infoWsp = null;
				this.infoWspError = infoWsp;
				if (WspDEBUG) console.log("Wsp do not exist:", infoWsp);
			}
			if (infoWsp.props && infoWsp.props.drfRefWsp) {
				this.reg.addToList("srcFields:shortDesc", "drfState", 1, "drfState");
			} else if (infoWsp.props && infoWsp.props.drvAxis) {
				this.reg.addToList("srcFields:shortDesc", "drvState", 1, "drvState");
			}
		} else {
			this.infoWsp = infoWsp; //null (erreur) ou undefined (à charger)
			this.infoWspError = infoWsp;
			this.reg.env.securityCtx = null;
		}
		this._dispatchWspLiveChange();
	}

	/** Construit le WspMetaUi. */
	protected async fetchWspMetaUi(): Promise<this> {
		try {
			const wspType = this.wspType;
			if (!wspType) throw Error("WspMeta definition not available");
			this._wspMetaUiLoading = createWspMetaUi(this.wspServer, wspType);
			const newWspUi = await this._wspMetaUiLoading;
			if (newWspUi == null) throw Error("WspMeta not found");
			if (this.wspType !== wspType) return; //raceCond chgt d'infoWsp entre temps.
			this.wspMetaUi = newWspUi;
			this.reg.copyFrom(this.wspMetaUi.reg);
		} catch (e) {
			if (e instanceof RespError) this.lastNetError = e;
			this.wspMetaUi = null;
			throw e;
		} finally {
			this._wspMetaUiLoading = undefined;
			this._dispatchWspLiveChange();
		}
		return this;
	}

	protected resetRemoteDatas() {
		this.infoWsp = undefined;
		this.infoWspError = undefined;
		this.resetMigrating();
		this.resetFullLoading();
		if (this.lastNetError) this.lastNetError = undefined;
		this.resetWspMetaUi();
		this._dispatchWspLiveChange();
	}

	protected resetWspMetaUi() {
		if (this.wspMetaUi) this.reg.resetExtPoints();
		this.wspMetaUi = undefined; //null -> undefined
		this._shortDescFields = null;
		this._longDescFields = null;
		this._shortDescDef = null;
		this._longDescDef = null;
	}

	equals(otherWsp: Wsp): boolean {
		return otherWsp && this.code === otherWsp.code;
	}

	toString() {return `Wsp(code:'${this.code}')`}
}

export class WspVersion extends Wsp {

	constructor(origin: Wsp, code: any, infoWsp?: JInfoWsp) {
		super(origin.wspServer, code, infoWsp);
	}
}

const WspDEBUG = false;


export interface IWspPointer {
	wsp?: Wsp
}

/** Un environnement de wsp est issu d'un env d'un universChain, avec le securityCtx dédié et le Wsp chargé. */
export type IWspEnv = IChainEnv & IWspPointer & ISecurityCtxPointer;

/** Contexte graphique avec un atelier: en plus de l'atelier une IWspsLivePlace par défaut et un IInfoBroker peuvent être disponibles. */
export type IWspUiEnv = IWspEnv & IWspsLivePlacePointer & IInfoBrokerPointer & IUiEnv;

//shortDesc
REG.reg.addToList('srcFields:shortDesc', 'item', 1, 'item');
//shortDesc odb
REG.reg.addToList('srcFields:shortDesc:odb', 'sdOdb', 1, 'sdOdb');
//shortDesc FS
REG.reg.addToList('srcFields:shortDesc:fs', 'sdFs', 1, 'sdFs');
REG.reg.addToList('srcFields:shortDesc:fs', 'gitSt', 1, 'gitSt');

//longDesc base
//REG.reg.addToList('srcFields:longDesc', 'itSubItems', 1, 'itSubItems');

//longDesc odb
//Si tasks ou resp sur items
// REG.reg.addToList('srcFields:longDesc:odb', 'rspUsrs', 1, 'rspUsrs');
//Si tasks
// REG.reg.addToList('srcFields:longDesc:odb', 'actStage', 1, 'actStage');
// REG.reg.addToList('srcFields:longDesc:odb', 'actCts', 1, 'actCts');

/**
 *
 */
export namespace WSPMETA {

	/**
	 * Crée une structure DOM à partir d'un JWspTypeInst, utilisable à la création d'un atelier par exemple.
	 */
	export function toWspTypeDom(wspTypeInst: JWspTypeInst): Element {
		const elt = DOM.newDomDoc().createElement("wspType");
		elt.setAttribute("key", wspTypeInst.wspType.key);
		if (wspTypeInst.wspType.uri) elt.setAttribute("uri", wspTypeInst.wspType.uri);
		if (wspTypeInst.wspType.version) elt.setAttribute("version", wspTypeInst.wspType.version);
		if (wspTypeInst.wspType.lang) elt.setAttribute("lang", wspTypeInst.wspType.lang);
		if (wspTypeInst.wspType.title) elt.setAttribute("title", wspTypeInst.wspType.title);
		if (wspTypeInst.wspOptions) for (const wspOpt of wspTypeInst.wspOptions) {
			const optElt = elt.appendChild(elt.ownerDocument.createElement("wspOption"));
			optElt.setAttribute("key", wspOpt.key);
			if (wspOpt.uri) optElt.setAttribute("uri", wspOpt.uri);
			if (wspOpt.version) optElt.setAttribute("version", wspOpt.version);
			if (wspOpt.lang) optElt.setAttribute("lang", wspOpt.lang);
			if (wspOpt.title) optElt.setAttribute("title", wspOpt.title);
		}
		return elt;
	}

	/** Cache pour la manipulation d'un grand nombre d'ateliers : mutialisation du JWspTypeInst et du WspMetaUi chargé. */
	export class WspMetasCache {

		protected wspTypeInstAtoms = new Map<string, JWspTypeInst>();
		protected wspMetaUis = new Map<string, Promise<WspMetaUi>>();
		protected fetched: Map<string, WspMetaUi>;

		constructor(public wspSrv: WspSrv) {}

		/** Mutualisation des JWspTypeInst (micro-optimisation). */
		atomWspTypeInst(wspTypeInst: JWspTypeInst): JWspTypeInst {
			const id = getWspTypeInstId(wspTypeInst);
			const w = this.wspTypeInstAtoms.get(id);
			if (w) return w;
			this.wspTypeInstAtoms.set(id, wspTypeInst);
			return wspTypeInst;
		}

		/** Déclaration d'un JWspTypeInst dans ce cache. */
		fetchWspMetaUi(wspTypeInst: JWspTypeInst): Promise<WspMetaUi> {
			const id = getWspTypeInstId(wspTypeInst);
			let w = this.wspMetaUis.get(id);
			if (!w) {
				w = createWspMetaUi(this.wspSrv, wspTypeInst);
				this.wspMetaUis.set(id, w);
			}
			return w;
		}

		/** Attend que tous les JWspTypeInst déclarés via fetchWspMetaUi() soient bien chargés. */
		async waitForAll(): Promise<void> {
			let done = 0;
			const total = this.wspMetaUis.size;
			if (!total) return;
			const fetched = new Map<string, WspMetaUi>();
			let finished: (v: unknown) => void;
			for (let entry of this.wspMetaUis) {
				entry[1].then((wspMetaUi) => {
					fetched.set(entry[0], wspMetaUi);
					if (++done === total) finished(undefined);
				}, (err) => {
					if (++done === total) finished(undefined);
				})
			}
			await new Promise((resolved) => {finished = resolved});
			this.fetched = fetched;
			// Promise.all = echec complet si un seul échoue => pas bon
			// const ids = [...this.wspMetaUis.keys()];
			// const promises = [...this.wspMetaUis.values()];
			// const w = await Promise.all(promises);
			// this.fetched = new Map();
			// for (let i = 0; i < ids.length; i++) this.fetched.set(ids[i], w[i]);
		}

		/** Offre un accès synchrone WspMetaUi à partir d'un JWspTypeInst, après un appel à waitForAll(). */
		getWspMetaUi(wspTypeInst: JWspTypeInst): WspMetaUi | null {
			return this.fetched?.get(getWspTypeInstId(wspTypeInst));
		}
	}

	function getWspTypeInstId(wspTypeInst: JWspTypeInst & { _id?: string }): string {
		if (wspTypeInst._id) return wspTypeInst._id;
		const uris = [wspTypeInst.wspType.uri];
		wspTypeInst.wspOptions?.forEach((opt) => uris.push(opt.uri));
		uris.sort();
		return wspTypeInst._id = uris.join('\n');
	}
}


/** States distants issus du renouvellement de la connexion. */
export type JWspWorkingInitStates = {
	[uri: string/*wspUri*/]: {
		srcDt: number
		srcStamp?: string
		reject?: 'perm' | 'conflict'
		states: JWspWorkingState[]
	}
}

/** Etat d'un device concernant une uri. */
export type JWspWorkingState = {
	state: EWspWorkingSt
	account: string
	clId: string
}

export type JWspUriChangeMsg = {
	svc: 'wspChanges'
	type: EWspChangesEvts
	wspCd: string
	srcUri: string
	srcId?: string
	itSt?: EItStatus // si type = EWspChangesEvts.s
	itModel?: string //uniquement si le user connecté est impliqué dans les responsabilités de cette source.
	involved?: boolean //uniquement si le user connecté est impliqué dans les responsabilités de cette source.
	/** Peut être renseigné en cas de dispatch local. */
	shortDesc?: JSrcFields
}

export type JWspStChangeMsg = {
	svc: 'wspChanges'
	wspCd: string
	wspSt: 'loading' | 'loaded' | 'fullLoading' | 'fullLoaded' | 'migrating' | 'migratingDone' | 'migratingFailed' | 'closed'
}


export type JItemInfo = {
	srcUri: srcUri
	cPbs: JItemSsError[]
}

export type JItemSsError = {
	ty: 'Error' | 'Warning'
	code: string
	msg: string
	details?: string
}

/** Liste de skinsets d'un WSP **/
export type JSkinSets = {
	editMode: "white" | "black"
	skinSets: JSkinSetEntry[]
}

export type JSkinSetEntry = {
	code: string
	version: number
	title: string
	selected: boolean
}

/** Msgs du serveur pour la house slave. */
export type JMoanServerMsg = {
	svc: 'moan'
	houseId: wspRef
	type: 'initSlaveRep'
}

/**
 *
 */
export namespace WSP {

	export function buildWspUri(wspCd: wspCd, srcUri: srcUri): wspUri {return wspCd + srcUri}

	export function buildWspId(wspCd: wspCd, srcId: srcId): wspId {return wspCd + "/" + srcId}

	export function buildWspRef(wspCd: wspCd, ident: JSrcIdent | srcRef): wspRef {
		if (typeof ident === 'string') return SRC.isSrcId(ident) ? buildWspId(wspCd, ident) : buildWspUri(wspCd, ident);
		return ident.srcId ? buildWspId(wspCd, ident.srcId) : buildWspUri(wspCd, ident.srcUri);
	}

	export function isWspUriRoot(wspUri: wspUri): boolean {return wspUri && wspUri.indexOf('/') < 0}


	export function extractWspCdFromWspRef(wspRef: wspRef): wspCd {
		if (!wspRef) return null;
		const end = wspRef.indexOf('/');
		if (end > 0) return wspRef.substring(0, end);
		return end < 0 ? wspRef : null;
	}

	export function extractSrcRefFromWspRef(wspRef: wspRef): srcRef {
		if (!wspRef) return null;
		const start = wspRef.indexOf('/');
		if (start > 0) {
			const srcRef = wspRef.substring(start + 1);
			if (SRC.isSrcId(srcRef)) return srcRef;
			return wspRef.substring(start);
		}
		if (start == 0) return null; //anomalie : pas de wspCd !
		return SRC.URI_ROOT;
	}

	/** Tri d'une liste d'ateliers par ordre de profondeur (DRV, DRF/DRF, ...) croissante **/
	export function sortWspsByDeep(wsps: Wsp[]): Wsp[] {
		//console.log("INI ::: ", wsps);
		let wspsDeep: Map<string, number> = new Map<string, number>();

		function computeDeep(wspCode: string): number {
			if (wspsDeep.has(wspCode))
				return wspsDeep.get(wspCode);
			else {
				let wsp: Wsp = wsps.find((entry) => entry.code === wspCode);
				let wspDeep = 0;
				if (wsp) {
					let infoWsp = wsp.infoWsp || wsp.infoWspError;
					if (infoWsp.props.drfRefWsp)
						wspDeep = computeDeep(infoWsp.props.drfRefWsp) + 1;
					else if (infoWsp.props.drvMasterWsp)
						wspDeep = computeDeep(infoWsp.props.drvMasterWsp) + 1;
				}
				wspsDeep.set(wspCode, wspDeep);
				return wspDeep;
			}
		}

		wsps.forEach((entry) => {computeDeep(entry.code)});
		wsps.sort((a, b): number => {
			return wspsDeep.get(a.code) - wspsDeep.get(b.code);
		});
		//console.log("SORTED ::: ", wsps);
		return wsps;
	}

	export function defaultWspOpenMode(reg: IReg<IChainEnv>): 'wspApp' | 'wspDocApp' | null {
		if (reg.getUserData("wspAppPrefered")) {
			if (reg.hasPerm("ui.wspApp")) return 'wspApp';
			if (reg.hasPerm("ui.wspDocApp")) return 'wspDocApp';
		} else {
			if (reg.hasPerm("ui.wspDocApp")) return 'wspDocApp';
			if (reg.hasPerm("ui.wspApp")) return 'wspApp';
		}
		return null;
	}

	export function alternateWspOpenMode(reg: IReg<IChainEnv>): 'wspApp' | 'wspDocApp' | null {
		if (reg.getUserData("wspAppPrefered")) {
			if (reg.hasPerm("ui.wspDocApp")) return 'wspDocApp';
			if (reg.hasPerm("ui.wspApp")) return 'wspApp';
		} else {
			if (reg.hasPerm("ui.wspApp")) return 'wspApp';
			if (reg.hasPerm("ui.wspDocApp")) return 'wspDocApp';
		}
		return null;
	}

	interface JListWsp {
		wspProvider: JWspProviderProps
		wsps: JWspInfoInList[]
	}

	export async function listWsps(wspServer: WspSrv, options?: {
		inTrash?: boolean
		withWspSrcSpecifiedRoles?: boolean
		fields?: ESrcField[]
	}): Promise<JListWsp> {
		let qs: string;
		if (options) {
			const opts: string[] = [];
			if (options.fields) opts.push("fields", options.fields.join('*'));
			if (options.withWspSrcSpecifiedRoles) opts.push("withWspSrcSpecifiedRoles", "true");
			qs = IO.qs("cdaction", options.inTrash ? "ListTrash" : "List", ...opts);
		} else {
			qs = "?cdaction=List";
		}
		return wspServer.config.adminWspUrl.fetchJson<JListWsp>(qs);
	}

	export async function fetchInfoWspProvider(wspServer: WspSrv): Promise<JWspProviderProps> {
		return wspServer.config.adminWspUrl.fetchJson(IO.qs("cdaction", "InfoWspProvider"));
	}

	/**
	 * Exporte la config des affectations de rôles cet entrepot : groupes, users, ateliers et espaces
	 * @param wspServer
	 */
	export async function fetchExportAssignedRoles(wspServer: WspSrv, options?: {
		withWspSrcSpecifiedRoles?: boolean
		fields?: ESrcField[]
	}): Promise<JWspProviderRolesSet> {
		const opts: string[] = [];
		if (options?.fields) opts.push("fields", options.fields.join('*'));
		if (options?.withWspSrcSpecifiedRoles) opts.push("withWspSrcSpecifiedRoles", "true");

		return wspServer.config.adminWspUrl.fetchJson(IO.qs("cdaction", "ExportAssignedRoles", ...opts));
	}

	export async function fetchSrc(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef, fields: ESrcField[]): Promise<JSrcFields> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchJson(IO.qs("param", wsp.code, "refUri", refUri, "fields", fields.join("*")));
	}

	export async function fetchSrcs(wsp: Wsp, uiContext: HTMLElement, refUris: srcRef[], fields: string | ESrcField[]): Promise<(JSrcFields | null)[]> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const data = new FormData();
		data.append("refUris", refUris.join('\t'));
		return wsp.wspServer.config.wspSrcUrl.fetchJson<JSrcFields[]>(IO.qs("param", wsp.code, "fields", Array.isArray(fields) ? fields.join('*') : fields), {
			method: 'POST',
			body: data
		});
	}

	export async function fetchShortDesc(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef): Promise<JSrcFields> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchJson(IO.qs("param", wsp.code, "refUri", refUri, "fields", wsp.getShortDescDef()))
	}

	export function fetchShortDescs(wsp: Wsp, uiContext: HTMLElement, ...refUris: srcRef[]): Promise<(JSrcFields | null)[]> {
		return fetchSrcs(wsp, uiContext, refUris, wsp.getShortDescDef());
	}

	export function fetchShortDescsSubItems(wsp: Wsp, uiContext: HTMLElement, ...refUris: srcRef[]): Promise<(JSrcFields | null)[]> {
		return fetchSrcs(wsp, uiContext, refUris, wsp.getShortDescDef() + "*itSubItems");
	}

	export async function fetchShortDescSubItems(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef): Promise<JSrcFields> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchJson(IO.qs("param", wsp.code, "refUri", refUri, "fields", wsp.getShortDescDef() + "*itSubItems"))
	}

	export async function fetchLongDesc(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef): Promise<JSrcFields> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchJson(IO.qs("param", wsp.code, "refUri", refUri, "fields", wsp.getLongDescDef()))
	}

	export function fetchLongDescs(wsp: Wsp, uiContext: HTMLElement, ...refUris: srcRef[]): Promise<(JSrcFields | null)[]> {
		return fetchSrcs(wsp, uiContext, refUris, wsp.getLongDescDef());
	}

	export async function fetchShortDescTree(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef, depth: number = 1): Promise<JSrcFieldsTree> {
		return fetchSrcTree(wsp, uiContext, refUri, depth, wsp.getShortDescDef());
	}

	export async function fetchSrcTree(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef, depth: number, fields: string | ESrcField[]): Promise<JSrcFieldsTree> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchJson(IO.qs("param", wsp.code, "refUri", refUri, "depth", depth, "fields", Array.isArray(fields) ? fields.join('*') : fields))
	}

	export async function fetchShortDescSubTree(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef, targets: srcRef | srcRef[]): Promise<JSrcFieldsTree> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		if (Array.isArray(targets)) targets = targets.join(';');
		return wsp.wspServer.config.wspSrcUrl.fetchJson(IO.qs("param", wsp.code, "refUri", refUri, "targets", targets, "fields", wsp.getShortDescDef()))
	}

	export async function fetchItemInfo(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef): Promise<JItemInfo> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchJson<JItemInfo>(IO.qs("param", wsp.code, "refUri", refUri, "format", "itemInfo"))
	}

	/** @return path fileSystem de la ressource (accessible uiniquement dans le mode "universe.locale", et FS) */
	export async function fetchFilePath(wsp: Wsp, uiContext: HTMLElement, refUri: srcRef): Promise<string> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		if (wsp.reg.env.universe.config.local && wsp.reg.env.universe.config.backEnd == "fs")
			return wsp.wspServer.config.wspSrcUrl.fetchText(IO.qs("param", wsp.code, "refUri", refUri, "format", "filePath"));
	}

	/**
	 * <pre>
	 * [request]
	 *  [select resultType="entries|count" max="200" startOffset=""]
	 *    [column dataKey="..."/]
	 *    [column dataKey="..." name="" /]
	 *    ...
	 *    [column name="..." func="..."]...[/column]
	 *  [/select]
	 *  [where]
	 *    [exp type="..."]...[/exp]
	 *    [and]...[/and]
	 *    [or]...[/or]
	 *    [not]...[/not]
	 *  [/where]
	 * [/request]
	 * </pre>
	 *
	 */
	export async function fetchSearch(wsp: Wsp, uiContext: HTMLElement, req: string): Promise<{ columns: string[], results: any[][] }> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "Search", "param", wsp.code);
		return wsp.wspServer.config.searchUrl.fetchJson<any>(qs, {method: "POST", body: req});
	}

	export async function fetchSearchJson<T>(wsp: Wsp, uiContext: HTMLElement, req: string): Promise<T[]> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "Search", "param", wsp.code, "format", 'json');
		return wsp.wspServer.config.searchUrl.fetchJson<any>(qs, {method: "POST", body: req});
	}

	export async function fetchSearchCount(wsp: Wsp, uiContext: HTMLElement, req: string): Promise<number> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "Search", "param", wsp.code);
		return Number.parseInt(await wsp.wspServer.config.searchUrl.fetchText(qs, {method: "POST", body: req}));
	}

	export async function fetchSearchCsv(wsp: Wsp, uiContext: HTMLElement, req: string): Promise<string> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "Search", "param", wsp.code, "format", 'csv');
		return wsp.wspServer.config.searchUrl.fetchText(qs, {method: "POST", body: req});
	}

	export async function fetchSearchScWsp(wsp: Wsp, uiContext: HTMLElement, req: string): Promise<Blob> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "Search", "param", wsp.code, "format", 'scwsp');
		return wsp.wspServer.config.searchUrl.fetchBlob(qs, {method: "POST", body: req});
	}

	/** Récupère le srcId d'une uri en forçant au besoin sa création (besoin pour édition des méta dans les items par ex...). */
	export async function fetchSrcId(wsp: Wsp, uiContext: HTMLElement, srcUri: srcUri, force: boolean): Promise<srcUri> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return (await wsp.wspServer.config.wspSrcUrl.fetchJson<JSrcFields>(IO.qs("param", wsp.code, "refUri", srcUri, "fields", "srcId", "forceId", force ? "" : undefined))).srcId;
	}

	/** Interroge un agent d'une gen et retourne le résultat */
	export async function fetchAskAgt(wsp: Wsp, uiContext: HTMLElement, genCode: string, dialogPath: string): Promise<Document> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspAgtUrl.fetchDom(IO.qs("cdaction", "Ask", "param", wsp.code, "contextCode", genCode, "dialogPath", dialogPath));
	}

	// export async function fetchSrcUri(wsp: Wsp, srcId: srcId): Promise<srcUri> {
	// 	return (await wsp.wspServer.config.wspSrcUrl.fetchJson<JSrcFields>(IO.qs("param", wsp.code, "refUri", srcId, "fields", "srcUri"))).srcUri;
	// }
	//
	// export async function fetchSrcIdentFromWspRef(wspServer: WspServer, wspRef: wspRef): Promise<JSrcIdent> {
	// 	return (await wspServer.config.wspSrcUrl.fetchJson<JSrcFields>(IO.qs("param", WSP.extractWspCdFromWspRef(wspRef), "refUri", WSP.extractSrcRefFromWspRef(wspRef), "fields", "srcUri*srcId")));
	// }

	export async function fetchStreamJson<R>(wsp: Wsp, uiContext: HTMLElement | null, refUri: srcRef, transform?: string): Promise<R> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchJson<R>(IO.qs("format", "stream", "param", wsp.code, "probeContentType", "true", "transform", transform, "refUri", refUri));
	}

	export async function fetchStreamText(wsp: Wsp, uiContext: HTMLElement | null, refUri: srcRef, transform?: string): Promise<string> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchText(IO.qs("format", "stream", "param", wsp.code, "probeContentType", "true", "transform", transform, "refUri", refUri));
	}

	export async function fetchStreamDom(wsp: Wsp, uiContext: HTMLElement | null, refUri: srcRef, transform?: string): Promise<Document> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchDom(IO.qs("format", "stream", "param", wsp.code, "probeContentType", "true", "transform", transform, "refUri", refUri));
	}

	export function getStreamUrl(wsp: Wsp, refUri: srcRef, transform?: string): IEndPoint {
		return wsp.wspServer.config.wspSrcUrl.resolve(IO.qs("format", "stream", "param", wsp.code, "probeContentType", "true", "transform", transform, "refUri", refUri));
	}

	/** Ajout d'une empreinte du fichier courant dans l'URL pour invalider le cache local du navigateur. */
	export function getStreamStampedUrl(wsp: Wsp, refUri: srcRef, stamp: string | number, transform?: string): string {
		return wsp.wspServer.config.wspSrcUrl.resolve(IO.qs("format", "stream", "param", wsp.code, "probeContentType", "true", "transform", transform, "refUri", refUri, "srcTrashed", "false", "stamp", stamp)).url;
	}

	export async function fetchDiff(wsp: Wsp, uiContext: HTMLElement, baseRef: srcRef, candidateWspCd: wspCd, candidateRef: srcRef | ESpecialCandidateUri): Promise<Document> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "GetDiff", "goal", "diff4xed", "param", wsp.code, "candidateWspCd", candidateWspCd, "baseRefUri", baseRef, "candidateRefUri", candidateRef);
		return wsp.wspServer.config.diffUrl.fetchDom(qs);
	}

	export type ESpecialCandidateUri = "special:drf:ref" | "special:drv:default" | "special:drv:done" | "special:drv:default:done";

	export async function fetchHistory(wsp: Wsp, uiContext: HTMLElement, srcRefLive: srcRef, fields?: string | ESrcField[]): Promise<JSrcHistNodes> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.historyUrl.fetchJson<JSrcHistNodes>(IO.qs("cdaction", "ListHistoryNodes", "param", wsp.code, "refUriLive", srcRefLive, "fields", Array.isArray(fields) ? fields.join('*') : fields || wsp.getShortDescDef()));
	}

	export async function fetchSrcTrashed(wsp: Wsp, uiContext: HTMLElement, folder: srcRef, fields?: string | ESrcField[]): Promise<JSrcHistNodes> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.historyUrl.fetchJson<JSrcHistNodes>(IO.qs("cdaction", "ListTrashedNodes", "param", wsp.code, "refUriLive", folder, "fields", Array.isArray(fields) ? fields.join('*') : fields || wsp.getShortDescDef()));
	}

	export async function createWsp(wspServer: WspSrv, params: JWspCreateParamsFS | JWspCreateParamsDB | JWspCreateParamsDB_DRF | JWspCreateParamsDB_DRV, wspType: JWspTypeInst, normalizeWspType?: boolean): Promise<Wsp>;
	export async function createWsp(wspServer: WspSrv, params: any, wspType: JWspTypeInst, normalizeWspType?: boolean): Promise<Wsp>;
	export async function createWsp(wspServer: WspSrv, params: any, wspType: JWspTypeInst, normalizeWspType: boolean = false): Promise<Wsp> {
		const initReq = {method: "PUT", body: DOM.ser(WSPMETA.toWspTypeDom(wspType))} as RequestInit;
		const qs = IO.qs("cdaction", "CreateWsp", "createParams", CDM.stringify(params), "normaliseWspType", normalizeWspType);
		const infoWsp = await wspServer.config.adminWspUrl.fetchJson<JInfoWsp>(qs, initReq);
		return new Wsp(wspServer, infoWsp.wspCd, infoWsp);
	}

	export async function importWsp(wspServer: WspSrv, params: JWspCreateParamsFS | JWspCreateParamsDB | JWspCreateParamsDB_DRF | JWspCreateParamsDB_DRV, scwsp: IBody, normalizeWspType?: boolean): Promise<Wsp>;
	export async function importWsp(wspServer: WspSrv, params: any, scwsp: IBody, normalizeWspType?: boolean): Promise<Wsp>;
	export async function importWsp(wspServer: WspSrv, params: any, scwsp: IBody, normalizeWspType: boolean = false): Promise<Wsp> {
		const initReq = {} as RequestInit;
		initReq.method = "POST";
		initReq.body = scwsp as any; //bug ts2.7 oubli URLSearchParams
		const qs = IO.qs("cdaction", "CreateWspImport", "createParams", CDM.stringify(params), "normaliseWspType", normalizeWspType);
		const infoWsp = await wspServer.config.adminWspUrl.fetchJson<JInfoWsp>(qs, initReq);
		return new Wsp(wspServer, infoWsp.wspCd, infoWsp);
	}

	/** retourne true si un wspMeta existe déjà dans le répertoire de cet atelier à créer */
	export async function fetchExistWspFsOnPath(wspServer: WspSrv, wspCode: string, contentPath?: string): Promise<JWspTypeInst | null> {
		const resp = await wspServer.config.adminWspFsUrl.fetchJson<JInfoWsp>(IO.qs("cdaction", "CheckWspOnPath", "param", wspCode, "contentPath", contentPath));
		if ((resp.status as any) === 'noActiveWsp')
			return resp;
	}

	export async function createSpaceOrFolder(wsp: Wsp, fromPlace: WspsLivePlace | null, uiContext: HTMLElement, srcUri: srcUri): Promise<JSrcFields> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const newSrc = await wsp.wspServer.config.wspSrcUrl.fetchJson<JSrcFields>(IO.qs("cdaction", "PutSrc", "param", wsp.code, "asFolder", "true", "clId", wsp.wspServer.chain.clId, "refUri", srcUri, "fields", wsp.getShortDescDef()), {method: "POST"});
		if (ITEM.getSrcUriType(newSrc.srcUri) === "res") {
			const itemFields = await wsp.fetchShortDesc(ITEM.extractItemUri(newSrc.srcUri));
			wsp.wspServer.wspsLive.dispatchLocalChange(fromPlace, wsp, itemFields, EWspChangesEvts.u, itemFields);
		} else {
			wsp.wspServer.wspsLive.dispatchLocalChange(fromPlace, wsp, newSrc, EWspChangesEvts.u, newSrc);
		}
		return newSrc;
	}

	/** Recherche d'une refUri inexistante */
	export async function findNewRefUri(wsp: Wsp, candidateSrcUriConstructor: (cnt: number) => srcUri | null, maxChecks = 1000): Promise<srcUri | null> {
		let cnt: number = 0;
		let target: srcUri;
		while (!target && cnt < maxChecks) {
			const candidate: srcUri = candidateSrcUriConstructor(cnt);
			if (!candidate) return;
			const node = await WSP.fetchSrcTree(wsp, null, candidate, 0, ["srcSt"]);
			if (node.srcSt != ESrcSt.none)
				cnt++;
			else
				return (candidate)
		}
	}

	/** Retourne les srcUri résultant de la copie (utile si renommages à la volée en cas de conflit de noms dans l'espace cible). */
	export async function srcCopyTo(wsp: Wsp, uiContext: HTMLElement, sources: srcRef[], newParentUri: srcRef): Promise<srcUri[]> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const fd = new FormData();
		fd.append("refUris", sources.join('\t'));
		const srcUris = await wsp.wspServer.config.wspSrcUrl.fetchText(IO.qs("cdaction", "CopyTo", "param", wsp.code, "refUri", newParentUri), {method: "POST", body: fd});
		return srcUris.split('\t');
	}

	/** Retourne les srcUri résultant du déplacement (utile si renommages à la volée en cas de conflit de noms dans l'espace cible). */
	export async function srcMoveTo(wsp: Wsp, uiContext: HTMLElement, sources: srcRef[], newParentUri: srcRef): Promise<srcUri[]> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const fd = new FormData();
		fd.append("refUris", sources.join('\t'));
		const srcUris = await wsp.wspServer.config.wspSrcUrl.fetchText(IO.qs("cdaction", "MoveTo", "param", wsp.code, "refUri", newParentUri), {method: "POST", body: fd});
		return srcUris.split('\t');
	}

	export async function srcMove(wsp: Wsp, uiContext: HTMLElement, from: srcRef, newUri: srcUri): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return wsp.wspServer.config.wspSrcUrl.fetchVoid(IO.qs("cdaction", "Move", "param", wsp.code, "refUri", newUri, "refUris", from), {method: "POST"});
	}

	export async function srcRename(wsp: Wsp, uiContext: HTMLElement, from: JSrcIdent, newCode: string): Promise<srcUri> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const newUri = SRC.addLeafToUri(SRC.extractUriParent(from.srcUri), newCode);
		await wsp.wspServer.config.wspSrcUrl.fetchVoid(IO.qs("cdaction", "Rename", "param", wsp.code, "refUri", newUri, "refUris", from.srcUri), {method: "POST"});
		return newUri;
	}

	export async function srcDuplicate(wsp: Wsp, uiContext: HTMLElement, from: JSrcIdent, newCode: string): Promise<srcUri> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const newUri = SRC.addLeafToUri(SRC.extractUriParent(from.srcUri), newCode);
		await wsp.wspServer.config.wspSrcUrl.fetchVoid(IO.qs("cdaction", "Duplicate", "param", wsp.code, "refUri", newUri, "refUris", from.srcUri), {method: "POST"});
		return newUri;
	}

	export async function srcDelete(wsp: Wsp, uiContext: HTMLElement, refUris: srcRef[]): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const fd = new FormData();
		fd.append("refUris", refUris.join('\t'));
		return wsp.wspServer.config.wspSrcUrl.fetchVoid(IO.qs("cdaction", "Delete", "param", wsp.code), {method: "POST", body: fd});
	}

	export async function srcRestore(wsp: Wsp, uiContext: HTMLElement, srcRefs: srcRef[]): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const fd = new FormData();
		fd.append("srcUris", srcRefs.join('\t'));
		return wsp.wspServer.config.historyUrl.fetchVoid(IO.qs("cdaction", "RestoreTrashed", "param", wsp.code), {method: "POST", body: fd});
	}

	export async function srcDeletePermanently(wsp: Wsp, uiContext: HTMLElement, srcUris: srcRef[]): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const fd = new FormData();
		fd.append("srcUris", srcUris.join('\t'));
		return wsp.wspServer.config.historyUrl.fetchVoid(IO.qs("cdaction", "DeletePermanently", "param", wsp.code), {method: "POST", body: fd});
	}

	export async function srcSetRoles(wsp: Wsp, uiContext: HTMLElement, srcRef: srcRef, specifiedRoles: JUserSpecifiedRolesMap): Promise<JUserRolesMap> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "SetSpecifiedRoles", "param", wsp.code, "refUri", srcRef, "options", CDM.stringify(specifiedRoles));
		return wsp.wspServer.config.wspSrcUrl.fetchJson(qs, {method: "POST"});
	}

	/** Roles actuellement affectés sur l'objet srcRef */
	export async function srcGetRoles(wsp: Wsp, uiContext: HTMLElement, srcRef: srcRef): Promise<JUserRolesMap> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "GetSrc", "param", wsp.code, "format", "specifiedRoles", "refUri", srcRef);
		return wsp.wspServer.config.wspSrcUrl.fetchJson(qs);
	}

	/** Roles des users passés en argument sur l'objet srcRef */
	export async function srcGetRolesForAccounts(wsp: Wsp, uiContext: HTMLElement, srcRef: srcRef, pAccounts: string[]): Promise<JUserRolesMap> {
		if (!pAccounts || pAccounts.length == 0) return {};
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "GetSrc", "param", wsp.code, "format", "specifiedRoles", "refUri", srcRef, "forUser", pAccounts.join("\t"));
		return wsp.wspServer.config.wspSrcUrl.fetchJson(qs);
	}

	export async function srcUpdateFields(wsp: Wsp, uiContext: HTMLElement, srcRef: srcRef, fields: JSrcFields): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const qs = IO.qs("cdaction", "UpdateFields", "param", wsp.code, "refUri", srcRef, "options", CDM.stringify(fields));
		return wsp.wspServer.config.wspSrcUrl.fetchVoid(qs, {method: "POST"});
	}


	/** Vérifie l'existance d'un svc de l'atelier **/
	export async function checkWspSvc(wsp: Wsp, uiContext: HTMLElement, svcCode: string): Promise<boolean> {
		const resp = await wsp.wspServer.config.wspSvcExistUrl.resolve(encodeURIComponent(wsp.code) + "/" + svcCode).fetch();
		return resp.ok;
	}

	/** [SvcSkinSet] SkinSet disponibles pour cet atelier **/
	export async function skinSetsList(wsp: Wsp, uiContext: HTMLElement, lang?: string): Promise<JSkinSets> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		return await wsp.wspServer.config.wspSvcSkinSet(wsp.code).fetchJson(IO.qs("cdaction", "ListSkinSets", "lang", lang));
	}

	/** [SvcSkinSet] : Icone d'un skinSet, ou d'un skin d'une skinClass **/
	export function skinSetsIconUrl(wsp: Wsp, skinCode: string, skinClass?: string): string {
		return wsp.wspServer.config.wspSvcSkinSet(wsp.code).resolve(IO.qs("cdaction", "GetIcon", "skinCode", skinCode, "skinClass", skinClass)).url;
	}

	/** Trouve le Reg ancêtre de niveau Wsp, sans autre surcharge.*/
	export function findWspReg(reg: IReg<IWspUiEnv>): IReg<IWspUiEnv> {
		while (reg && reg.parentReg && reg.parentReg.env.wsp) reg = reg.parentReg;
		return reg;
	}

	/** [SvcAdminWsp] RemoveCache **/
	export async function removeCache(wsp: Wsp): Promise<void> {
		return await wsp.wspServer.config.adminWspUrl.fetchVoid(IO.qs("cdaction", "RemoveCache", "param", wsp.code), {method: "POST"});
	}

	/** [SvcAdminWsp] ReloadWsp **/
	export async function reloadWsp(wsp: Wsp): Promise<void> {
		return await wsp.wspServer.config.adminWspUrl.fetchVoid(IO.qs("cdaction", "ReloadWsp", "param", wsp.code), {method: "POST"});
	}
}

class FetchSrcDescPending {
	promise: Promise<JSrcFields | null>;
	resolve: (value: JSrcFields | null) => void
	reject: (e: any) => void
	srcRefSub: srcRefSub

	constructor(bulk: FetchSrcDescBulk, srcRefSub: srcRefSub, public withSubItem: boolean) {
		this.srcRefSub = srcRefSub;
		this.promise = new Promise<JSrcFields | null>((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;
		});
		bulk.set(srcRefSub, this);
	}
}

class FetchSrcDescBulk extends Map<srcRefSub, FetchSrcDescPending> {
	constructor(public wsp: Wsp, public uiContext: HTMLElement) {
		super();
		Promise.resolve().then(() => {
			this.wsp._pendingShortDescs = null;
			const pendings: FetchSrcDescPending[] = [];
			const pendingsWSI: FetchSrcDescPending[] = [];
			for (const p of this.values()) {
				if (p.withSubItem) pendingsWSI.push(p)
				else pendings.push(p);
			}
			if (pendings.length > 0) WSP.fetchShortDescs(this.wsp, this.uiContext, ...(pendings.map(p => p.srcRefSub))).then((results) => {
				for (let i = 0; i < pendings.length; i++) {
					try {
						pendings[i].resolve(results[i]);
					} catch (e) {
						ERROR.log("Fail to resolve one fetch bulk: " + pendings[i].srcRefSub, e);
					}
				}
			})
			if (pendingsWSI.length > 0) WSP.fetchShortDescsSubItems(this.wsp, this.uiContext, ...(pendingsWSI.map(p => p.srcRefSub))).then((results) => {
				for (let i = 0; i < pendingsWSI.length; i++) {
					try {
						pendingsWSI[i].resolve(results[i]);
					} catch (e) {
						ERROR.log("Fail to resolve one fetch bulk: " + pendingsWSI[i].srcRefSub, e);
					}
				}
			})
		}).catch((e) => {
			for (const p of this.values()) {
				try {p.reject(e)} catch (e) {console.error(e)}
			}
		});
	}
}

/** LazyLoadung WspMetaUi.createWspMetaUi : optimisation chargement initial et résolution cycles */
async function createWspMetaUi(wspServer: WspSrv, wspMeta: JWspTypeInst): Promise<WspMetaUi> {
	if (!_createWspMetaUi) _createWspMetaUi = (await import("lib/wsp/wspMetaUi.js")).WspMetaUi.createWspMetaUi;
	return _createWspMetaUi(wspServer, wspMeta);
}

let _createWspMetaUi: (wspServer: WspSrv, wspMeta: JWspTypeInst) => Promise<WspMetaUi>;
